



















































































































import BaseComponent from '@/components/base-component.vue';
import CollapsibleCard from '@/components/UI/collapsible-card.vue';
import InputMoney from '@/components/UI/input-money.vue';
import UiPrescriptionVolumeTotal from '@/components/UI/prescription-volume-total.vue';
import { decimalFormat } from '@/helpers/decimalFormat';
import { sortKey } from '@/helpers/sort';
import { toNumber } from '@/helpers/toNumber';
import { hasSpecialCharacters } from '@/helpers/validations';
import IClientUnit from '@/interfaces/clientUnit';
import { AlterDadosBasicPrescrParmDTO, PrescricaoParmDTO } from '@/interfaces/prescription';
import { MedidasProdutosEnteralResult } from '@/interfaces/product';
import { TerapiaUsoDTO } from '@/interfaces/therapy';
import { TranscricaoOcrResult } from '@/interfaces/transcricao-ocr';
import * as unitService from '@/services/client-unit';
import * as parameterService from '@/services/parameters';
import {
  ADMINISTRATION_WAYS_CENTRAL, ADMINISTRATION_WAYS_CENTRAL_LABEL, ADMINISTRATION_WAYS_PERIPHERAL, ADMINISTRATION_WAYS_PERIPHERAL_LABEL
} from '@/settings/consts/prescription-params';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import BagModelQuantity from '../bag-model-quantity.vue';
import BasicInfosPrescriptionFormDialog from './basic-infos-form-dialog.vue';
import {InfosHelper} from './infos-helper'

@Component({
  components: {
    InputMoney,
    CollapsibleCard,
    UiPrescriptionVolumeTotal,
    BagModelQuantity,
    BasicInfosPrescriptionFormDialog
  },
})
export default class PrescriptionFormInfos extends BaseComponent {
  @Prop()
  public item;
  @Prop()
  public disabled?: boolean;
  @Prop()
  public terapiaUso: TerapiaUsoDTO;
  @Prop()
  public ocr: TranscricaoOcrResult; 
  @Prop()
  public draft: PrescricaoParmDTO; 
  @Prop()
  public typesReady: boolean;  
  @Prop()
  public enteralResult: MedidasProdutosEnteralResult;
  @Prop({default: 0})
  public openRegisterFormKey: number;

  editFormOpened = false;

  public rules: any = {
    divisao_bolsa: [(v) => !!v || 'Selecione uma divisão de bolsa'],
    via_administracao: [(v) => !!v || 'Selecione uma via de administração'],
    tempo_infusao: [(v) => !!v || 'Selecione o tempo de infusão'],
    leito: [(v) => hasSpecialCharacters(v)],
    registro: [(v) => this.validRegistro(v)]
  };

  public infusionTimeLoading: boolean = false;
  public infusionTimeOptions: any[] = [];

  public administrationWays: any[] = [
    {
      value: ADMINISTRATION_WAYS_CENTRAL,
      label: ADMINISTRATION_WAYS_CENTRAL_LABEL,
    },
    {
      value: ADMINISTRATION_WAYS_PERIPHERAL,
      label: ADMINISTRATION_WAYS_PERIPHERAL_LABEL,
    },
  ];

  public typeVolumeTotal: boolean = true;
  public sectors: any[] = [];

  @Watch('item.paciente')
  public onChangePaciente(): void {
    if (!!this.item.paciente) {
      this.item.same = this.item.paciente.same;
    }
  }

  @Watch('item.unidade')
  public onChangeClientUnit(val: IClientUnit): void {
    if (this.item.isVisualization() || this.item.isCopy()) {
      this.sectors.push(this.item.setor);
    } else if (!!val && !!val.id) {
      this.addSubsc(unitService.getSetoresUnidade(val.id).subscribe((setores) => {
        this.sectors = setores;
      }));
    }
    this.fetchInfusionTime(val);
  }

  @Watch('ocr')
  public onChangeOcr(ocr: TranscricaoOcrResult): void {    
    if (!ocr || !ocr.idPaciente) {
      return;
    }
    
    this.sleepUntil(() => {
      return this.item && this.typesReady && this.item.paciente && this.item.paciente.completo && this.infusionTimeOptions && this.infusionTimeOptions.length;
    }, 180000).then(() => {
      if (!!ocr.registro) {
        this.item.registro = ocr.registro;
      }
      if (!!ocr.leito) {
        this.item.leito = ocr.leito;
      }
      if (!!ocr.volumeDesejado) {
        this.item.volumeDesejado =  new String(ocr.volumeDesejado).toString();
        this.onChangeVolumeTotal(this.item.volumeDesejado);
      }
      if (!!ocr.divisaoBolsas) {
        this.item.divisaoBolsas = ocr.divisaoBolsas;
        this.onChangeDivisaoBolsa(this.item.divisaoBolsas);
      }
      if (!!ocr.viaAdministracao) {
        this.item.viaAdministracao = ocr.viaAdministracao;
        this.onChangeViaAdministracao(this.item.viaAdministracao);
      }
      if (!!ocr.tempoInfusao) {
        this.item.tempoInfusao = ocr.tempoInfusao;
        this.onChangeTempoInfusao(this.item.tempoInfusao);
      } else if (!this.item.tempoInfusao) {
        this.item.tempoInfusao = 24;
        this.onChangeTempoInfusao(this.item.tempoInfusao);
      }
    });
  }

  @Watch('draft')
  public onChangeDraft(draft: PrescricaoParmDTO): void {
    let ocr = new TranscricaoOcrResult();
    ocr.idPaciente = draft.idPaciente;
    ocr.registro = draft.registro;
    ocr.leito = draft.leito;
    ocr.volumeDesejado = draft.volumeBolsaMl;
    ocr.divisaoBolsas = draft.divisaoBolsas;
    ocr.viaAdministracao = draft.viaAdministracao;
    ocr.tempoInfusao = draft.tempoInfusao;

    this.onChangeOcr(ocr);

    this.item.setor = draft.idSetor;
  }
  

  public fetchInfusionTime(unidade?: IClientUnit) {
    const filter = {
      idMedico: !!this.item.medico ? this.item.medico.id : null,
      idUnidade: !!this.item.unidade ? this.item.unidade.id : null,
    };

    if (
      !this.item.isEdit() &&
      !this.item.isVisualization() &&
      !this.item.isTranscriptionCopy() &&
      !this.item.isCopy() &&
      !this.item.isPattern()
    ) {
      this.item.tempoInfusao = null;
    }

    this.infusionTimeLoading = true;

    parameterService.getInfusionTime(filter).subscribe(
      (data) => {
        this.infusionTimeLoading = false;
        this.infusionTimeOptions = data.valores
          .map((i) => ({
            text: `${i.valor} hora${i.valor != 1 ? 's' : ''}`,
            value: toNumber(i.valor),
          }))
          .sort(sortKey('value'));
      },
      () => {
        this.infusionTimeLoading = false;
      },
    );
  }

  public formatValue(value: number): string {
    return decimalFormat(value);
  }

  public onChangeVolumeTotalByWeight(val: number): void {
    this.item.volumeFinalMlKgDia = val;
  }

  public onChangeVolumeTipo(val: boolean): void {
    this.item.volumeDigitadoPorKg = val;
  }

  public onChangeVolumeTotal(val: number): void {
    if (!this.item.isVisualization()) {
      this.item.volumeDesejado = val;      
    }
    this.$emit('changeMLDia');
  }

  public onChangeDivisaoBolsa(val): void {
    this.$emit('changeDivisaoBolsa', val);
  }

  public onChangeViaAdministracao(val): void {
    this.$emit('changeViaAdministracao', val);
  }

  public onChangeTempoInfusao(val): void {
    this.$emit('changeTempoInfusao', val);
  }

  public onToogleVolumeType(type): void {
    this.typeVolumeTotal = type;
  }

  public canUseTypedVolume(): boolean {
    return (
      !this.item.isPattern() &&
      !this.item.isProfile() &&
      !this.item.isCopy() &&
      !this.item.isModel() &&
      !this.item.isVisualization() &&
      !this.item.isTranscriptionCopy() &&
      !this.terapiaUso &&
      !this.ocr &&
      !this.enteralResult &&
      (!this.draft || !this.draft.volumeBolsaMl)
    );
  }

  regexpRegistro = null;

  @Watch('item.unidade.registroValidacaoRegexp', {immediate: true})
  onValidacaoRegexpChange(v) {    
    this.regexpRegistro = InfosHelper.buildRegExpValidRegistro(this.item ? this.item.unidade : null)
  }
  
  validRegistro(v: string) {
    if (!v) {
      // não validar ao prescrever, se nao foi informado
      return true;
    }
    return InfosHelper.validRegistro(v, this.item ? this.item.unidade : null, this.regexpRegistro);
  }

  isPodeAlterar() {
    return (
      this.item 
      && this.item.permissao 
      && this.item.permissao.usuarioPodeAlterDadosBasicos
    );
  }

  prepareAlter() {
    this.item.invalidRegisterMsg = null;
    this.item.functionCallbackAfterSetRegister = null;
    this.editFormOpened = true;
  }

  alteracaoSalva(parm: AlterDadosBasicPrescrParmDTO) {
    this.editFormOpened = false;
    this.item.registro = parm.registro;
    this.item.invalidRegisterMsg = null;
  }

  alteracaoCancelada() {
    this.editFormOpened = false;
    this.item.invalidRegisterMsg = null;
    this.item.functionCallbackAfterSetRegister = null;
  }

  @Watch('openRegisterFormKey')
  onOpenRegisterFormKeyChange(o, n) {
    if (o == n) {
      return;
    }
    this.editFormOpened = true;
  }
  
}
